import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { Rating } from "react-simple-star-rating";
import { mainServerAppUrl } from "../../apis/mainApi";
import { Header } from "../Header/header";
import { Footer } from "../Footer/footer";

export const OrderAccept = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ ALWAYS ARRAY
  const [allOrders, setAllOrders] = useState([]);


  // ✅ LOAD ORDERS (NAVIGATION OR LOCALSTORAGE)
  useEffect(() => {
    if (Array.isArray(location.state)) {
      setAllOrders(location.state);
      localStorage.setItem("orders", JSON.stringify(location.state));
    } else {
      const storedOrders =
        JSON.parse(localStorage.getItem("orders")) || [];
      setAllOrders(storedOrders);
    }
  }, [location.state]);

  // ✅ ACCEPT / DECLINE ORDER
  const acceptDecline = async (id, order, action) => {
    try {
      const res = await axios.post(
        `${mainServerAppUrl}/orders/${action}/${id}`
      );
// console.log(res, "shouryaa");
//       if (action === "accept") {
//         await payment(id, order);
//       }

      // ✅ SAFE STATE UPDATE
      
      setAllOrders((prev) => {
        const updatedOrders = prev.filter(
          (item) => item._id !== id
        );
        localStorage.setItem(
          "orders",
          JSON.stringify(updatedOrders)
        );
        return updatedOrders;
      });
      console.log(res,"response");
console.log(res?.data?.meal_name, "meal name");
     const mealName =
  res?.data?.meal_name ||
  res?.data?.order?.meal_name ||
  order.meal_name;

action === "accept"
  ? toast.success(
      `Order Accepted\n${mealName}`,
      { duration: 5000 }
    )
  : toast.error(
      `Order Declined\n${mealName}`,
      { duration: 5000 }
    );

    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Something went wrong"
      );
    }
  };

  // ✅ PAYMENT FLOW
  const payment = async (orderId, order) => {
    try {
      const res = await axios.post(
        `${mainServerAppUrl}/patron/payment/invoice`,
        { orderId }
      );

      toast.success(res.data.message);
      navigate("/patron-contact", { state: order });
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Payment failed"
      );
    }
  };

  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return (
    <div className="max-resolution">
      <Header />

      <section className="title_box">
        <div className="container">
          <h2>MEAL HOST ACCEPT OR DECLINE</h2>
          <p>
            Accept or decline patron orders in real time.
          </p>
        </div>
      </section>

      {/* ✅ NO ORDERS */}
      {allOrders.length === 0 && (
        <p className="text-center mt-4">
          No orders available
        </p>
      )}

      {/* ✅ ORDERS LIST */}
      {allOrders.map((order) => (
        <main key={order._id}>
          <div className="container">
            <div className="custom-form centered mb-4">
              <div className="green_box_history meal-order mt-4">

                <div className="text-center">
                  <p>{order.patron}</p>
                  <Rating
                    initialValue={order.ratings}
                    readonly
                    allowFraction
                    size={22}
                  />
                  <span>
                    ({order.num_of_reviews})
                  </span>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${order.imageUrl}`}
                      alt="meal"
                    />
                  </div>

                  <div className="col-6">
                    <p>
                      {
                        weekday[
                          new Date(
                            order.ordered_On
                          ).getDay()
                        ] 
                      }
                    </p>
                    <small>{order.meal_type}</small>
                    <br />
                    <small>{order.meal_name}</small>
                    <br />
                    <small>
                      Quantity:{" "}
                      {order.order_quantity}
                    </small>
                  </div>

                  <div className="col-3">
                    <p>${order.price}</p>
                    <p>
                      <strong>
                        Total: $
                        {order.price *
                          order.order_quantity}
                      </strong>
                    </p>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-6">
                    <button
                      className="btn_form w-100"
                      onClick={() =>
                        acceptDecline(
                          order._id,
                          order,
                          "accept"
                        )
                      }
                    >
                      ACCEPT
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      className="btn_form bg-pink w-100"
                      onClick={() =>
                        acceptDecline(
                          order._id,
                          order,
                          "decline"
                        )
                      }
                    >
                      DECLINE
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </main>
      ))}

      <Footer />
    </div>
  );
};
